import { JourneysLegacyRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';
import { Navigate } from '@/utils/navigate';
import { legacyPasswordRedirect } from './-password-redirects';
import { LegacySignupRedirect } from './-signup-redirects';

function UsersRoute() {
  const { _splat } = Route.useParams();
  const firstSegment = (_splat ?? '').split('/')[0];
  // Legacy `/users/login` (Unity) → canonical Hydra `/login`. Everything else
  // under /users (bar the password links `beforeLoad` forwards) stays with the embedded app.
  if (firstSegment === 'login') {
    // Preserve any query params (e.g. `?origin`, `?token`) the legacy link carried.
    const search = Object.fromEntries(new URLSearchParams(window.location.search));
    return <Navigate to="/login" replace={true} search={search} />;
  }
  // Legacy signup aliases always redirect to /signup in the shell — signup is
  // unconditionally Hydra-owned (FPS-2872 cutover).
  if (firstSegment === 'register' || firstSegment === 'signup') {
    return <LegacySignupRedirect />;
  }
  return <JourneysLegacyRoute />;
}

export const Route = createFileRoute('/users/$')({
  beforeLoad: ({ params }) => {
    const target = legacyPasswordRedirect(params._splat ?? '', window.location.search);
    if (target != null) {
      throw target;
    }
  },
  component: UsersRoute,
});
